import React from "react";
import { Link } from "react-router-dom";
import { Box, Image } from "@chakra-ui/react";
import Logo from "../../../../assets/images/logo.svg";

function Layout(props) {
	return (
		<Box w={"full"} paddingBottom="20px" height={"100%"}>
			<Box display="flex" alignItems="center" justifyContent="space-between">
				<Link to="/login">
					<Box>
						<Image width="50%" src={Logo} />
					</Box>
				</Link>
			</Box>
			{props.children}
		</Box>
	);
}

export default Layout;
